import { Popover, PopoverProps } from '@pypestream/design-system';
import { FC, PropsWithChildren } from 'react';

export interface GenericPopoverProps {
  width?: 'default' | 'auto';
  trigger: string;
  popoverRef: React.RefObject<PopoverProps> | null;
  onClose?: () => void;
}

export const GenericPopover: FC<PropsWithChildren<GenericPopoverProps>> = ({
  width = 'default',
  trigger,
  popoverRef,
  children,
}) => {
  return (
    <Popover width={width} trigger={trigger} ref={popoverRef}>
      {children}
    </Popover>
  );
};
